import type { MrpLocation, MrpTransferReason } from "@/lib/mrp";

export interface DraftNonPo {
  cpn: string;
  location_code: MrpLocation;
  quantity: string;
  expected_arrival: string;
  source: string;
  notes: string;
  tracking_number: string;
  tracking_carrier: string;
}

export const EMPTY_DRAFT: DraftNonPo = {
  cpn: "",
  location_code: "sgs",
  quantity: "",
  expected_arrival: "",
  source: "",
  notes: "",
  tracking_number: "",
  tracking_carrier: "",
};

export interface DraftTransfer {
  cpn: string;
  quantity: string;
  origin_location_id: string;
  destination_location_id: string;
  ship_by_date: string;
  reason: MrpTransferReason;
  notes: string;
}

export const EMPTY_TRANSFER_DRAFT: DraftTransfer = {
  cpn: "",
  quantity: "",
  origin_location_id: "",
  destination_location_id: "",
  ship_by_date: "",
  reason: "upcoming_needs",
  notes: "",
};
